import React, { PropTypes } from 'react';
import ReactDOMServer from 'react-dom/server';
import $ from 'jquery';
import { bootstrapUI } from 'plugins/bootstrap';
import ReactDOM from 'react-dom';
import ResourceCard from 'common/components/ResourceCard';
import bindMultirefs from 'plugins/multiref-checkboxes';
import { serializeManip } from './reducers/manip';
import {
  renderCreateForType,
  renderEditForType,
  validateForType,
  getProductManipulations,
} from './api';
import { tryParseNumber } from 'utils/parse';
require('plugins/forms');

export const displayCreation = (intervention, type, zone, saveCb) => {
  const modal = html => <CreateModal content={html} />;

  return renderCreateForType(type).then(content =>
    drawModal(intervention, type, zone, modal, content, saveCb)
  );
};

export const displayEdition = (
  intervention,
  data,
  type,
  saveCb,
  deleteCb,
  disabled,
  deletable
) => {
  const modal = html => (
    <EditModal
      content={html}
      type={type}
      disabled={disabled}
      deletable={deletable}
    />
  );

  return renderEditForType(type, data).then(content =>
    drawModal(
      intervention,
      type,
      data.zone_id,
      modal,
      content,
      saveCb,
      deleteCb,
      data,
      disabled
    )
  );
};

const bindMarkerState = ($modal, resourceState) => {
  const images = $modal.find('.mood.image');
  const fullImages = $modal.find(`img.mood[data-full="true"]`);
  const emptyImages = $modal.find(`img.mood:not([data-full="true"])`);

  images.each((_, elem) => {
    const $elem = $(elem);
    const full = $elem.data('full');
    const name = $elem.data('name');

    if (!full) {
      $elem.on('click', () => {
        fullImages.hide();
        emptyImages.show();

        $elem.hide();
        const fullImage = $modal.find(
          `img[data-name="${name}"][data-full="true"]`
        );
        fullImage.show();
        resourceState.icon = name;
      });
    } else {
      $elem.on('click', () => {
        const emptyImage = $modal.find(
          `img.mood[data-name="${name}"][data-full!="true"]`
        );

        $elem.hide();
        emptyImage.show();
        resourceState.icon = undefined;
      });
    }
  });
};

function drawModal(
  intervention,
  type,
  zone,
  renderModal,
  content,
  saveCb,
  deleteCb,
  existing,
  disabled = false
) {
  const html = {
    __html: content,
  };

  // Creating modal from server modal
  const modal = ReactDOMServer.renderToStaticMarkup(renderModal(html));

  // Appending content to body
  $(document.body).append(modal);

  let resourceState;

  if (existing) {
    resourceState = {
      image_before: existing.image_before,
      image_after: existing.image_after,
      icon: existing.icon,
    };
  } else {
    resourceState = {};
  }

  function serialize(data) {
    let obj = {};
    let captureRegex = /species_captures\[(\w+)\]/;
    for (let [key, value] of data) {
      if (obj[key] !== undefined) {
        if (!Array.isArray(obj[key])) {
          obj[key] = [obj[key]];
        }
        if (key === 'species') {
          if (value && value !== '') {
            obj['species'].push(parseInt(value, 0));
          }
        } else {
          obj[key].push(value);
        }
      } else {
        let captureGroups = key.match(captureRegex);

        if (captureGroups != null && captureGroups.length > 0) {
          if (obj['species_captures'] === undefined) {
            obj['species_captures'] = [];
          }

          let speciesId = parseInt(captureGroups[1], 0);
          let speciesValue = value !== '' ? parseInt(value, 10) : null;
          obj['species_captures'].push({
            species: speciesId,
            value: speciesValue,
          });
        } else if (key === 'species' || key === 'species[]') {
          // for insect
          if (obj['species'] === undefined) {
            obj['species'] = [];
          }

          if (value && value !== '') {
            obj['species'].push(parseInt(value, 0));
          }
        } else {
          if (
            value !== undefined &&
            value !== null &&
            (value === '' || value.length > 0)
          ) {
            if (key === 'zone_id') {
              obj[key] = parseInt(value, 10);
            } else {
              obj[key] = value;
            }
          } else {
            var parsed = parseInt(value, 0);
            if (isNaN(parsed) || key === 'species_captures[]')
              // species_captures[] for other pests
              obj[key] = value;
            else obj[key] = parsed;
          }
        }
      }
    }
    return obj;
  }

  // Handling events
  const $modal = $('#manip-modal');
  $modal
    .modal({
      onShow: () => {
        const $refs = $('#manip-modal .checkBoxList');
        const $inputs = $('#manip-modal .input');
        const $rawInputs = $('#manip-modal input');
        const $dropdowns = $('#manip-modal .dropdown');
        const $textareas = $('#manip-modal textarea');

        if (disabled) {
          $refs.addClass('disabled');
          $dropdowns.addClass('disabled');
          $inputs.addClass('disabled');
          $rawInputs.prop('disabled', true);
          $textareas.prop('disabled', true);
        }
      },
      onApprove: $element => {
        const $button = $($element);
        $button.addClass('loading');

        // Validate form remotely
        const $form = $modal.find('form');
        const data = new FormData($form[0]);
        const zoneId: Number = tryParseNumber(zone);
        data.append('zone_id', zoneId);
        const manipulationDiv = document.getElementById('manipulations');
        const dataType = manipulationDiv.dataset.type;
        var serializedForm;
        if (dataType !== 'ANNEX_1' || dataType !== 'ANNEX_2') {
          serializedForm = serialize(data); //JSON.parse(JSON.stringify($form.serializeObject()));
        } else {
          serializedForm = JSON.parse(JSON.stringify($form.serializeObject()));
        }

        validateForType(type, data).then(
          _ => {
            $button.removeClass('loading');

            const saved = handleValidatedForType(type, serializedForm, $modal);
            saveCb({
              ...(existing || {}),
              ...saved,
              ...resourceState,
            });

            $modal.modal('hide');
          },
          err => {
            $button.removeClass('loading');

            // Display error message
            err.res
              .text()
              .then(content => $modal.find('.content').html(content))
              .then(_ =>
                handleContentForType(
                  intervention,
                  type,
                  $modal,
                  existing,
                  resourceState
                )
              );
          }
        );

        return false;
      },
      onDeny: $element => {
        deleteCb(existing || {});
        return true;
      },
      onVisible: () =>
        handleContentForType(
          intervention,
          type,
          $modal,
          existing,
          resourceState,
          disabled
        ),
      onHidden: () => $modal.remove(),
    })
    .modal('show');
}

function bindManipResourceCards(resourceState, disabled) {
  const $resources = $('.resource.card');
  $resources.each((index, element) => {
    const $element = $(element);

    const name = $element.attr('data-name');
    const title = $element.attr('data-title');
    const value = $element.attr('data-value');
    const mini = $element.attr('data-mini');
    const thumbnail = $element.attr('data-thumbnail');

    // Building resource
    const resource = {
      id: value,
      mini,
      web: thumbnail,
    };

    function handleResourceChange(e) {
      resourceState[name] = e;
    }

    function handleResourceDelete(e) {
      resourceState[name] = 'deleted';
    }

    if (resourceState[name] && resourceState[name] === 'deleted') {
      ReactDOM.render(
        <ResourceCard
          name={name}
          title={title}
          onChange={handleResourceChange}
          onDelete={handleResourceDelete}
          canUpdate={!disabled}
          canDelete={!disabled}
        />,
        element
      );
    } else if (resourceState[name]) {
      ReactDOM.render(
        <ResourceCard
          name={name}
          title={title}
          raw={resourceState[name]}
          onChange={handleResourceChange}
          onDelete={handleResourceDelete}
          canUpdate={!disabled}
          canDelete={!disabled}
        />,
        element
      );
    } else {
      ReactDOM.render(
        <ResourceCard
          name={name}
          title={title}
          resource={resource}
          onChange={handleResourceChange}
          onDelete={handleResourceDelete}
          canUpdate={!disabled}
          canDelete={!disabled}
        />,
        element
      );
    }
  });
}
function handleContentForType(
  intervention,
  type,
  $modal,
  existing,
  resourceState,
  disabled
) {
  // Ignoring type for now, as fields do not seem to change
  bootstrapUI($modal);
  bindMultirefs();

  bindManipResourceCards(resourceState, disabled);

  if (!disabled) {
    bindMarkerState($modal, resourceState);
  }

  $modal.find('.ui .resource .card').addClass('noMargin');

  const findDropdownByInput = name =>
    $modal.find(`input[name="${name}"]`).closest('.dropdown');

  const loadProductDropdown = ($dropdown, product) => {
    $dropdown.removeClass('disabled').addClass('loading');

    const drawItem = (value, label) =>
      `<div class="item" data-value="${value}">${label}</div>`;

    const zonePointId =
      existing && parseInt(existing.id, 10) ? existing.id : undefined;
    getProductManipulations(product, intervention, zonePointId).then(
      availableManips => {
        const $preInstallInput = $('input[name="preinstall-hidden"]');
        const valueBefore = $dropdown.dropdown('get value');
        const refreshMenu = () => {
          const $menu = $dropdown.find('.menu');
          $menu.empty();

          if ($preInstallInput && $preInstallInput.length) {
            if (
              $preInstallInput.val() === 'study' ||
              $preInstallInput.val() === 'study-modal'
            ) {
              availableManips
                .filter(p => p.id === 146)
                .forEach(p => $menu.append(drawItem(p.id, p.label)));
            } else if (
              $preInstallInput.val() === 'intervention' ||
              $preInstallInput.val() === 'intervention-modal'
            ) {
              availableManips
                .filter(p => p.id !== 146)
                .forEach(p => $menu.append(drawItem(p.id, p.label)));
            } else {
              availableManips.forEach(p =>
                $menu.append(drawItem(p.id, p.label))
              );
            }
          } else {
            availableManips.forEach(p => $menu.append(drawItem(p.id, p.label)));
          }
        };

        refreshMenu();

        $dropdown.removeClass('loading');
        $dropdown.dropdown('refresh');
        $dropdown.dropdown('set value', valueBefore);
        $dropdown.dropdown('set selected', valueBefore);
      }
    );
  };

  const clearProductDropdown = $dropdown => {
    $dropdown.dropdown('clear');
    $dropdown.find('.menu').empty();
  };

  const loadLinkedDropDowns = () => {
    const links = [
      {
        name: 'product_id',
        dropdown: 'manip_id',
      },
      {
        name: 'comp_product_id',
        dropdown: 'comp_manip_id',
      },
    ];

    links.forEach(l => {
      const $dropdown = findDropdownByInput(l.name);
      const $linkDropdown = findDropdownByInput(l.dropdown);

      const value = $dropdown.dropdown('get value');
      if (value) {
        loadProductDropdown($linkDropdown, value);
      }

      // Bind linked dropdowns
      $dropdown.dropdown({
        onChange: val => {
          if (val) {
            loadProductDropdown($linkDropdown, val);
          } else {
            $linkDropdown.addClass('disabled');
            clearProductDropdown($linkDropdown);
          }
        },
      });
    });
  };

  loadLinkedDropDowns();
  const $preInstallInput = $('input[name="preinstall-hidden"]');
  const $manipDropdown = findDropdownByInput('manip_id');
  const $compManipDropdown = findDropdownByInput('comp_manip_id');

  const canUpdatePreinstallMode = val =>
    val &&
    val.length &&
    (!$preInstallInput.val() ||
      !$preInstallInput.val().length ||
      $preInstallInput.val() === 'unknown');

  const handleManipUpdate = val => {
    if (canUpdatePreinstallMode(val) && val === '146') {
      $preInstallInput.val('study-modal');
      loadLinkedDropDowns();
    } else if (canUpdatePreinstallMode(val)) {
      $preInstallInput.val('intervention-modal');
      loadLinkedDropDowns();
    } else {
      const hasValue =
        $manipDropdown.dropdown('get value') ||
        $compManipDropdown.dropdown('get value')
          ? true
          : false;
      if (
        !hasValue &&
        ($preInstallInput.val() === 'study-modal' ||
          $preInstallInput.val() === 'intervention-modal')
      ) {
        $preInstallInput.val('unknown');
        loadLinkedDropDowns();
      }
    }
  };
  $manipDropdown.dropdown({
    onChange: handleManipUpdate,
  });

  $compManipDropdown.dropdown({
    onChange: handleManipUpdate,
  });

  // Handling insect content behavior
  if (type === 'INSECT' || type === 'OTHER_PESTS') {
    const $species = $modal.find('#Species');

    $species.find('tbody > tr input[type="checkbox"]').on('change', evt => {
      const $element = $(evt.currentTarget);
      const $input = $element.closest('tr').find('.ui.dropdown, .ui.input');

      if (evt.currentTarget.checked) {
        $input.removeClass('disabled');
      } else {
        $input.addClass('disabled');
      }
    });
  }
}

function handleValidatedForType(type, data, $modal) {
  // Ignoring type for now, as fields do not seem to change

  const findDropdownByInput = name =>
    $modal.find(`input[name="${name}"]`).closest('.dropdown');

  const getDropdownText = name => {
    const $dropdown = findDropdownByInput(name);
    return $dropdown
      .find(`.menu > .item[data-value='${$dropdown.dropdown('get value')}']`)
      .html();
  };

  const fields = [
    {
      name: 'product_id',
      field: 'product_name',
    },
    {
      name: 'comp_product_id',
      field: 'comp_product_name',
    },
    {
      name: 'manip_id',
      field: 'manip_name',
    },
    {
      name: 'comp_manip_id',
      field: 'comp_manip_name',
    },
    {
      name: 'image_before_id',
      field: 'image_before',
    },
    {
      name: 'image_after_id',
      field: 'image_after',
    },
    {
      name: 'icon',
      field: 'icon',
    },
  ];

  // Bind dropdown values
  const obj = {};
  fields.forEach(f => {
    const text = getDropdownText(f.name);

    obj[f.name] = text && text.length ? data[f.name] : null;
    obj[f.field] = text;
  });

  const result = serializeManip({
    ...data,
    ...obj,
  });

  return result;
}

const CreateModal = ({ content }) => (
  <div id="manip-modal" className="ui small modal">
    <div className="header">Ajout d'une manipulation</div>
    <div className="scrolling content">
      <div dangerouslySetInnerHTML={content} />
    </div>
    <div className="actions">
      <button className="ui approve primary labeled icon button">
        <i className="icon add" />
        Ajouter
      </button>
    </div>
  </div>
);

CreateModal.propTypes = {
  content: PropTypes.object.isRequired,
};

const EditModal = ({ content, type, disabled, deletable }) => {
  const renderTitle =
    type === 'ANNEX_1' || type === 'ANNEX_2'
      ? 'Détail du repère'
      : 'Détail de la manipulation';

  return (
    <div id="manip-modal" className="ui small modal">
      <div className="header">{renderTitle}</div>
      <div className="scrolling content">
        <div dangerouslySetInnerHTML={content} />
      </div>
      {!disabled && (
        <div className="actions">
          <button className="ui approve primary labeled icon button">
            <i className="icon add" />
            Editer
          </button>
          {deletable && (
            <button className="ui deny left floated red labeled icon button">
              <i className="icon trash" />
              Supprimer
            </button>
          )}
        </div>
      )}
    </div>
  );
};

EditModal.propTypes = {
  content: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  EditModal: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/modals.js